<template>
    <div class="about_menu_top  textalign_left">
        <div style="background-color: #B43728;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 12189px;background: url('https://p1.fishqc.net/FotTG9RDPg642WSY-89uyV3HSzO0') center center no-repeat;background-size: auto 100%;">
                    <div style="width:1056px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:#533727;text-align: center;padding-top: 819px;box-sizing: border-box;font-size: 0">
                        <div v-for="item in productdata">
                            <div :class="[item.class]">
                                <img :src="item.img"  alt="">
                            </div>
                            <div class="newyear_title">{{item.dec}}</div>
                            <div v-for="val in item.dd">
                                <div class="newyear_box">
                                    <div class="tips_title">{{val.title}}</div>
                                    <div class="newyear_desc">{{val.destext}}</div>
                                    <div class="padding_top_28">
                                        <div  class="newyear_productbox  "  v-for="val1 in val.product" onclick="javascript:;"  @click="toproductdetail(val1.type,val1.id)">
                                            <div class="display_flex" style="width: 100%;">
                                                <div class="productImg" >
                                                    <img :src="val1.img">
                                                    <img v-if="val1.showgreen" src="https://p1.fishqc.net/FqSe-gp3KnUatHVptxWoeKWa_2Vp" class="greenFishicon">
                                                </div>
                                                <div class="flex-one display_flex justify-content_flex-justify flex-direction_column" style="text-align: left;padding-left:26px;box-sizing: border-box;padding-top: 41px;">
                                                    <div>
                                                        <div class="newyear_brand">{{val1.brand}}</div>
                                                        <div class="newyear_btitle">{{val1.title}}</div>
                                                    </div>
                                                    <div>
                                                        <div v-if="val1.effencyimgshow" style="padding-bottom: 12px;box-sizing: border-box;">
                                                            <img :src="val1.effencyimg">
                                                        </div>
                                                        <div class="newyear_tips">{{val1.tips}}</div>
                                                        <div  :class="[val1.paddingclass,'newyaer_address']">品牌所在地：{{val1.address}}</div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div style="margin:0 auto;text-align: center;padding-top:30px;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/FnDT2fTGZjsHMjFYuJa8nQA97V_p">
                    </div>
                    <div style="margin:0 auto;text-align: center;padding-top:10px;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/FpBFztaa4y_1mmmbg_b_D0JeAXjG">
                    </div>
                    <div style="margin:0 auto;text-align: center;padding-top:40px;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/FnYTQP5YLqwIZgcnMZRmSdJyQRTM">
                    </div>
                    <div style="margin:0 auto;text-align: center;padding-top:40px;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/FoQlf0kPFDMN5nJWjEdOar-L7uiM">
                    </div>
                    <div style="margin:0 auto;text-align: center;padding-top:40px;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/FqhRcJGSqYP1bLfoQKjRi5K6aV4Q">
                    </div>
                    <div style="margin:0 auto;text-align: center;padding-top:200px;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/Fiqplwa00FMo6aQNaEMUuccD0jmN">
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.vertival_align_middle {
    vertical-align: middle;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}

.desc1 {
    width: 902px;
    font-size: 30px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFE;
    line-height: 40px;
    text-align: left;
    margin: 26px auto 38px;

}

.box1,
.box2,
.box3 {
    width: 1000px;
    height: 408px;
    background: #B6412F;
    border-radius: 50px;
    padding: 50px 30px 50px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
}

.box_title {
    padding: 0 20px 0px;
    box-sizing: border-box;
    text-align: justify;
    font-size: 28px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;

}

.padding_bottom_25 {
    padding-bottom: 32px;
    box-sizing: border-box;
}

.title_padding {
    padding: 84px 0 25px;
    box-sizing: border-box;
}

.left_bg {
    position: absolute;
    left: -304px;
    top: 0;
    width: 361px;
    height: 349px;
    background-image: url('http://p1.fishqc.net/FmXC4OgM9qVQGkfPe06YgZi3x58r');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg {
    position: absolute;
    right: -224px;
    top: -80px;
    width: 457px;
    height: 554px;
    background-image: url(http://p1.fishqc.net/FrIy1r7aEfGRWVL-ByhoZBCSBQON);
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}


.left_bg1 {
    position: absolute;
    left: -240px;
    top: -70px;
    width: 522px;
    height: 572px;
    background-image: url(http://p1.fishqc.net/Fot0PDG8oTgWewT2YxSwTuUXprAe);
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;

}

.left_bg2 {
    position: absolute;
    left: -204px;
    bottom: 0;
    width: 305px;
    height: 220px;
    background-image: url('http://p1.fishqc.net/FtJFT3nczfgXq2dylsPddadutJcJ');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg2 {
    position: absolute;
    right: -318px;
    bottom: 0px;
    width: 492px;
    height: 361px;
    background-image: url('http://p1.fishqc.net/FjXjSHKZVDzqUfw6lF3VNrI-HqKD');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}

.innerbox {
    width: 454px;
    height: 160px;
    background: #C04431;
    box-shadow: 0px 1px 8px 0px rgba(250, 124, 99, 0.43);
    border-radius: 24px;
    cursor: pointer;
}

.product_left {
    width: 153px;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
}

.product_right {
    height: 100%;
    text-align: left;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #FEFEFE;
    line-height: 30px;
    padding-top: 26px;
    padding-right: 24px;
    box-sizing: border-box;
    flex:1;
}

.address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 32px;
}

.label {
    height: 29px;
    line-height: 29px;
    background: #FFF45C;
    border-radius: 16px 0px 16px 0px;
    text-align: center;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #B6412F;
    padding: 0 14px;
    box-sizing: border-box;
}

.left_bg3 {
    position: absolute;
    left: -202px;
    bottom: -114px;
    width: 293px;
    height: 534px;
    background-image: url('http://p1.fishqc.net/FmTEsrfvZD-6d3BA66xBRNam7LE2');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg3 {
    position: absolute;
    right: -304px;
    top: 164px;
    width: 361px;
    height: 347px;
    background-image: url('http://p1.fishqc.net/FnZceAGLeNDG6kZaoaOFnmxiEEwc');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}

.left_bg4 {
    position: absolute;
    left: -204px;
    bottom: 40px;
    width: 305px;
    height: 220px;
    background-image: url('http://p1.fishqc.net/FtJFT3nczfgXq2dylsPddadutJcJ');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg4 {
    position: absolute;
    right: -318px;
    bottom: 36px;
    width: 492px;
    height: 361px;
    background-image: url('http://p1.fishqc.net/FjXjSHKZVDzqUfw6lF3VNrI-HqKD');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}

.totaldesc {
    font-size: 35px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 52px;     
}


/*专题*/
.newyear_title{
    width: 1030px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 56px;
    margin:48px auto 30px;
}
.newyear_box{
    width: 1056px;
    /*height: 806px;*/
    background: #E25F42;
    border-radius: 24px;
    margin-bottom: 40px;
}

.tips_title{
    width: 270px;
    height: 70px;
    line-height: 70px;
    background: #FFB820;
    border-radius: 0px 0px 50px 50px;
    margin:0 auto;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #FEFEFE;
    text-align: center;
}

.newyear_desc{
    width: 994px;
    margin:0 auto;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    padding-top: 26px;
    box-sizing: border-box;
}

.padding_top_28{
    padding:28px 28px 16px;
    box-sizing: border-box;
}

.newyear_productbox{
    width: 488px;
    height: 269px;
    background: #FD7354;
    border-radius: 24px;
    margin-right: 24px;
    display: inline-block;
    margin-bottom: 24px;
    cursor: pointer;
    padding-left:20px;
    box-sizing: border-box;
}
.newyear_productbox:nth-child(even){
    margin-right: 0;
}

.padding_top_50{
    padding-top: 50px;
    box-sizing: border-box;
}

.productImg{
    width: 154px;
    height: 205px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 30px;
    display: inline-block;
    position: relative;
}

.newyear_brand{
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 24px;
}

.newyear_btitle{
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    padding-top: 9px;
    box-sizing: border-box;
}

.newyear_tips{
    height: 30px;
    line-height: 30px;
    background: #FFFCA0;
    border-radius: 12px 0px 12px 0px;
    padding:0 10px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FF7E00;

}

.newyaer_address{
    padding-top: 12px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
}

.greenFishicon{
    width: 88px;
    height: 88px;
    position: absolute;
    bottom: -15px;
    right: -15px;
}

.padding_bottom_6{
    padding-bottom: 6px;
    box-sizing: border-box;
}

.padding_bottom_22{
    padding-bottom: 22px;
    box-sizing: border-box;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata: [{

                    dec: '小仙女们的年度好物第一波必须是护肤优品，好好保养皮肤，皮肤就会以光彩照人的状态呈现。',
                    img:'https://p1.fishqc.net/FtekH2MNU-DdM0SryhrZYljZ6YSQ',
                    class:'',
                    dd: {
                        '1': {
                            destext: '面霜能有效的锁住我们肌肤内部的水分和营养，同时也能给肌肤补充水分和养分，进入冬季也依旧需要靠面霜来续命。',
                            destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                            title: '面霜',
                            
                            product: [{
                                img: 'https://p1.fishqc.net/FjUOLnGiCoy8lF-badodaxtCP4e-',
                                class: 'class1',
                                brand: "SHE LOG稀物集",
                                title: '松茸菌菇液晶霜',
                                tips: '日润养夜修护',
                                address: '中国',
                                type: 'cosmetic',
                                id: '8iPzTBozOtodf6KUIzUMlg',
                                height: 'heightclass1',
                                showgreen:false,
                                effencyimgshow:true,
                                effencyimg:'https://p1.fishqc.net/FlOm68EXTYxfxVL5ud1bGDYOU205',
                                paddingclass:'padding_bottom_6'

                            }, {
                                img: 'https://p1.fishqc.net/FmgP6zyplpm_xhVEwyh1PPH_Zcy6',
                                class: 'class9',
                                brand: 'SK-II',
                                title: '微肌因赋活修护精华霜',
                                tips: '细腻水润',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'RPp0dZOJ90kPn7FiSpNlMQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }, {
                                img: 'https://p1.fishqc.net/FvBKP44creUe6OfTrB6HaKuJpX4N',
                                class: 'class9',
                                brand: 'WINONA薇诺娜',
                                title: '舒敏保湿特护霜',
                                tips: '快速舒缓干痒红',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'fS0G53o9DCQJvtJiSgtvWQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }, {
                                img: 'https://p1.fishqc.net/FiUmZ3ULFqbK_BFxsL5sksi4Rt1n',
                                class: 'class9',
                                brand: "L'OREAL PARIS 欧莱雅",
                                title: '复颜玻尿酸水光充盈导入乳霜',
                                tips: '熬夜救星',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'T9qw0XcuDqOEqJ45l0K8oQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        },
                        '2': {
                            destext: '爽肤水能让角质层充分浸润，方便后续乳霜的涂抹以及吸收，让肤感和吸收度都上个台阶，妆面也能更加服帖通透。',
                            title: '爽肤水',
                            destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            product: [{
                                img: 'https://p1.fishqc.net/FijarV68HfaPKUgz5ZUUVWsIANR-',
                                class: 'class1',
                                brand: "My Clorisland 花皙蔻",
                                title: '洛神花细致毛孔精华水',
                                tips: '混油皮必备',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'BgdaLLepToHrcHu00hNxTg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'

                            }, {
                                img: 'https://p1.fishqc.net/FrbwB7354_5XchiWErt-whNcjqXr',
                                class: 'class2',
                                brand: "KIEHL'S科颜氏",
                                title: '金盏花爽肤水',
                                tips: '平衡水油',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'zGQjBENYdixdJQWnR5Ysiw',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        },
                        '3': {
                            destext: '涂抹式面膜比贴片式面膜更方便，上脸之后更自由。贴面膜都需要勇气的冬日，还是试试安全又滋润的涂抹式面膜吧。',
                            title: '面膜',
                            destext1: '需要选择合适的眼霜，缓解眼部皮肤问题。',
                            product: [{
                                img: 'https://p1.fishqc.net/FsyAvsb9BRHdi26brjH3edzzenei',
                                class: 'class7',
                                brand: "FRESH馥蕾诗",
                                title: '玫瑰润泽保湿舒缓面膜',
                                tips: '舒缓匀亮',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'Ie04onty4g8nEMATcW8FcA',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'

                            }, {
                                img: 'https://p1.fishqc.net/Ft-HT82_WDoLsSmdXqZsp4MNTHCj',
                                class: 'class6',
                                brand: 'EAU THERMALE AVENE 雅漾',
                                title: '修红舒润面膜',
                                tips: '水润保湿',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'Bft2kV6kQ9TY6ooulbCPeg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        },
                        '4': {
                            destext: '精华所富含的营养物质和活性物都高于普通护肤品，功能性更强，根据皮肤的需求选择合适安全的精华极其重要。',
                            title: '精华',
                            destext1: '需要选择合适的眼霜，缓解眼部皮肤问题。',
                            product: [{
                                img: 'https://p1.fishqc.net/FrQH6md-t0tZ721lGwO4RjwvXsrF',
                                class: 'class7',
                                brand: "OLAY玉兰油",
                                title: '纯璨晶透肌底精华露',
                                tips: '全能流光瓶',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'Mga3kkvuyAkz8jNtxqoZTQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'

                            }, {
                                img: 'https://p1.fishqc.net/Fkv-jYIDi7sQeqR-gTdLi1FTU1E_',
                                class: 'class6',
                                brand: 'LANEIGE兰芝',
                                title: '新水酷高保湿精华露（清润）',
                                tips: '干皮挚爱',
                                address: '韩国',
                                type: 'cosmetic',
                                id: 'WpTRkHcsA8btsbOWZMoP_w',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        }

                    },
                },
                {

                    dec: '除了面部皮肤的保养好物外，身体保养也是小仙女们重视的一环，让你从头到脚焕然一新的个护优品看小鱼的。',
                    img:'https://p1.fishqc.net/FgEpyZgWfkS8Z3dOFjbtKLU6OASc',
                    class:'padding_top_50',
                    dd: {
                        '1': {
                            destext: '发质脆弱易断，一梳就脱落，不只是头发的问题，更需要在意的是头皮的养护和毛囊的滋养。新的一年实现发量自由。',
                            destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                            title: '头皮精华',
                            
                            product: [{
                                img: 'https://p1.fishqc.net/FqhZBe7nn_tcY2N2pPFKGaeeRbxd',
                                class: 'class1',
                                brand: "麻茜",
                                title: '天麻头皮精华液',
                                tips: '秃头救星',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'g1ioAZjmxD33277vDAz8iA',
                                height: 'heightclass1',
                                effencyimgshow:true,
                                effencyimg:'https://p1.fishqc.net/Fspqw91DIo7FAgveQSC6wCwmKg4X',
                                paddingclass:'padding_bottom_6'

                            }, {
                                img: 'https://p1.fishqc.net/FtIH3EVCquXKm6PG0nh7zT4pHpy_',
                                class: 'class9',
                                brand: 'KERASTASE卡诗',
                                title: '赋源沁丝头皮防脱安瓶精华液',
                                tips: '硬核防脱',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'In1SyauAMbJC8MeiOt049A',
                                height: 'heightclass1',
                                effencyimgshow:true,
                                effencyimg:'https://p1.fishqc.net/Fi7WVw2Y1USBo_0ydpvgCW593IrZ',
                                paddingclass:'padding_bottom_6'
                            }]
                        },
                        '2': {
                            destext: '身体肌肤对比脸部皮肤，皮脂腺较少，油脂分泌也比较少，更容易出现干燥，更需要身体乳的加持，补充和锁住水分。',
                            title: '身体乳',
                            destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            product: [{
                                img: 'https://p1.fishqc.net/Fj4e9lHh0IIWyBAsWC4IXJPt_4JQ',
                                class: 'class1',
                                brand: "NIVEA妮维雅",
                                title: '深层润肤乳液',
                                tips: '长效保湿',
                                address: '德国',
                                type: 'cosmetic',
                                id: 'syRVqfvDqCizUwkg0irO1w',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'

                            }, {
                                img: 'https://p1.fishqc.net/Friquy5UZYwM48_oa3n39p59161O',
                                class: 'class2',
                                brand: 'SEBAMED施巴',
                                title: '保湿润肤露',
                                tips: '舒缓滋润',
                                address: '德国',
                                type: 'cosmetic',
                                id: 'XIH3TwOiX5vjlKcNH19j-w',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        },
                        '3': {
                            destext: '婴儿肌肤与成人存在很大差别，皮肤薄、透、对刺激物及有毒物质反应较为强烈，选择安全产品，保护宝宝肌肤健康。',
                            title: '儿童洗浴',
                            destext1: '需要选择合适的眼霜，缓解眼部皮肤问题。',
                            product: [{
                                img: 'https://p1.fishqc.net/FiKpzs-5vIcrlB3lLPahMCLlOPoW',
                                class: 'class7',
                                brand: "AVEENO艾惟诺",
                                title: '婴儿每日倍护沐浴洗发露',
                                tips: '温和无泪',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'ZgUTrBC3DpKcum_4E-3jGQ',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'

                            }, {
                                img: 'https://p1.fishqc.net/FhqWsjwBA0WgnEW17EuUoBWEaXox',
                                class: 'class6',
                                brand: 'CHERUB RUBS趣乐',
                                title: '全天然安全洗护婴儿沐浴洗发露',
                                tips: '温柔洁净',
                                address: '澳大利亚',
                                type: 'cosmetic',
                                id: 'IgL_n5d4DAb5mx_bettH3g',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        }
                        

                    }
                },{

                    dec: '美妆优品也是小仙女们的重点关注好物，安全美妆优品安排上，精致妆容跨年夜闪亮全场。',
                    img:'https://p1.fishqc.net/FllzGVH_qfWadf0O_vKdv6d9myTp',
                    class:'padding_top_50',
                    dd: {
                        '1': {
                            destext: '市面上好看的口红千千万，但稍不注意就会踩雷。劣质口红容易诱发过敏甚至炎症，选择安全口红跨年，拉满秋冬氛围感。',
                            destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                            title: '口红',
                            
                            product: [{
                                img: 'https://p1.fishqc.net/FsWWD0i79sdU3ijgo8kjQDmi_L20',
                                class: 'class1',
                                brand: "LANCOME兰蔻",
                                title: '菁纯柔雾哑光唇膏 (888 小野莓)',
                                tips: '持久滋润',
                                address: '法国',
                                type: 'cosmetic',
                                id: '9dr3BLU_d56XBHfFCXDxYA',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'

                            }, {
                                img: 'https://p1.fishqc.net/FuA0sKk53U6auBoWvUUxUnuNZjZy',
                                class: 'class9',
                                brand: 'MAC魅可',
                                title: '丝缎柔雾唇膏 (316 柔雾小辣椒)',
                                tips: '人气热卖',
                                address: '加拿大',
                                type: 'cosmetic',
                                id: 'CYxACmBEyq_ianLCl1nzcA',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        },
                        '2': {
                            destext: '眼影是妆容当中的点睛之笔，劣质眼影长时间接触皮肤，让皮肤发生病变，出现过敏性皮炎等问题，安全眼影好看又安心。',
                            title: '眼影',
                            destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                            product: [{
                                img: 'https://p1.fishqc.net/FqANDdLz_jnmwOxqrC9gK3lIx5Gw',
                                class: 'class1',
                                brand: "MAC魅可",
                                title: '时尚焦点小眼影-闪耀星辰系列(LAST DANCE)',
                                tips: '当季大热',
                                address: '加拿大',
                                type: 'cosmetic',
                                id: 'd-MfZkDkz1FmpaZUEDZZ1Q',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'


                            }, {
                                img: 'https://p1.fishqc.net/FkJR4zTON31TGw_XlqkZVFDbPd2o',
                                class: 'class2',
                                brand: 'CANMAKE井田',
                                title: '魅色星璨眼影 (14 古典深红)',
                                tips: '显色自然',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'ltFePk1nUYcInGsmUMN5Fg',
                                height: 'heightclass1',
                                showgreen:true,
                                paddingclass:'padding_bottom_22'
                            }]
                        }

                    }
                }
                

            ],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>